import { render, staticRenderFns } from "./QAManageModal.vue?vue&type=template&id=2ed149f9&scoped=true&"
import script from "./QAManageModal.vue?vue&type=script&lang=ts&"
export * from "./QAManageModal.vue?vue&type=script&lang=ts&"
import style0 from "./QAManageModal.vue?vue&type=style&index=0&id=2ed149f9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed149f9",
  null
  
)

export default component.exports